// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { firestorePlugin } from 'vuefire'
import firebase from 'firebase/app'
import 'firebase/firestore'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'
import '../theme/index.css'
import VueTimers from 'vue-timers'
import XlsxPopulate from 'xlsx-populate'
import 'vue-googlemaps/dist/vue-googlemaps.css'
import VueGoogleMaps from 'vue-googlemaps'

Vue.config.productionTip = false

// ElementUI
Vue.use(ElementUI, { locale })

// setup firebase instance and vueFire
Vue.use(firestorePlugin)

firebase.initializeApp({
  apiKey: 'AIzaSyDRsT8GWiyFC7enOHbINTTUZ9P71NmcAOg',
  authDomain: 'yunda-copy-v1-2021-2-4.firebaseapp.com',
  projectId: 'yunda-copy-v1-2021-2-4',
  storageBucket: 'yunda-copy-v1-2021-2-4.appspot.com',
  messagingSenderId: '235728573490',
  appId: '1:235728573490:web:2a47d02415f595afc3982b',
  measurementId: 'G-C7220GYBS3'
})
export const db = firebase.firestore()
const settings = { timestampsInSnapshots: true }
db.settings(settings)

export var xl = XlsxPopulate

// setup firebase auth instance
export const auth = firebase.auth()

// vueTimers
Vue.use(VueTimers)

// vue-googleMaps
Vue.use(VueGoogleMaps, {
  load: {
    // Google API key
    apiKey: 'AIzaSyCrRwx9LbSlq2M8SCNtghX8mTZPmrHHWRo',
    // Enable more Google Maps libraries here
    libraries: ['places', 'marker'],
    // Use new renderer
    useBetaRenderer: false
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  components: { App },
  template: '<App/>'
})
